var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Buttons/Auto Layout Horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H22C26.4183 0 30 3.58172 30 8V32C30 36.4183 26.4183 40 22 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 5,
    y: 12,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#152946"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    x: 5,
    y: 19,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#152946"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19",
    x: 5,
    y: 26,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMenuIcon);
export default __webpack_public_path__ + "static/media/black-menu-icon.e5402e4c8d145e345fc21b0c7d756aa1.svg";
export { ForwardRef as ReactComponent };